import { TFormFields, TFormSchema, useStore } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";
import axios from "axios";
import { api } from "@/comn";

/*
 * Configuration Common Schema !== 환경설정 공통 스키마 ==!
 */
export const COMN_SF_LPCO_SRCH: TFormFields = {
    srchAppCdNo: { type: "select", label: "L_LPCO", edit: true, all: true } /* lpco */,
    srchAppTp: {
        type: "select",
        label: "L_APP_TP",
        all: true,
        area: "comnCd",
        comnCd: "OSC0113",
    } /* Application Type */,
    srchAtcmTpCd: {
        type: "code",
        area: "comnCd",
        comnCd: "OSC0025",
        label: "L_DOC_TP_CD",
        popupSize: "lg",
    } /* Attachment Type Code !== 첨부문서 유형 코드 ==! */,
    srchUseYn: {
        type: "select",
        label: "L_USE_YN",
        area: "comnCd",
        comnCd: "OSC0101",
        select: false,
        all: true,
    } /* Use Yn */,
};

export const COMN_SG_LPCO_LIST_HEAD: Array<any> = [
    { cells: [{ header: "L_LPCO", binding: "appNm", width: "*" }] } /* Lpco Name */,
    { cells: [{ header: "L_APP_TP", binding: "appTpCd", width: 180 }] } /* Lpco Name */,
    { cells: [{ header: "L_DOC_TP_CD", binding: "atcmTpCd", width: "*" }] } /* Attachments Type */,
];

export const COMN_SG_LPCO_LIST_BODY: Array<any> = [
    { cells: [{ binding: "appNm", align: "left" }] },
    {
        cells: [
            {
                binding: "appTpCd",
                align: "center",
                area: "comnCd",
                comnCd: "OSC0113",
                type: "select",
                viewType: "label",
            },
        ],
    },
    { cells: [{ binding: "atcmTpCd", align: "left", area: "comnCd", comnCd: "OSC0025", type: "select" }] },
];
